import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery, select } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";
import { ChoosePurchaseModelDataTypes } from "../../../../Schema/choosePurchaseModel.types";
import { DiscountCodeTypes } from "../../discountCode/discountCode";
import { closeModal } from "../../modal/modal";
import { queryClient } from "../../../store";

export type BuySubServiceLoadAction = {
  type: string;
  payload: {
    sub_service_id?: number;
    use_wallet?: boolean;
    user_service_id: number;
    router?: any;
    serviceId?: number;
  };
};

export type BuySubServiceData = {
  data: ChoosePurchaseModelDataTypes;
};

const BuySubService = new ReduxFetchState<
  BuySubServiceData,
  {
    sub_service_id?: number;
    use_wallet?: boolean;
    user_service_id: number;
    router?: any;
    serviceId?: number;
  },
  any
>("buySubService");

export function* watchBuySubService(action: BuySubServiceLoadAction) {
  const lang: "fa" | "en" = yield getCurrentLanguage();

  try {
    const { sub_service_id, user_service_id, router, serviceId, use_wallet } = action.payload;

    const discountCode: DiscountCodeTypes = yield select(
      (state) => state.discountCode?.discountCode,
    ) || {};

    const host = window.location.hostname;

    const data: BuySubServiceData = yield axios({
      headers: {
        lang,
      },
      url: `/api/v1/ai/user-sub-service/buy-sub-service${discountCode?.code ? "?discount_code=" + discountCode?.code : ""}`,
      method: "POST",
      data: { sub_service_id, user_service_id, callback_url: window.location.href , use_wallet },
    });

    yield put(closeModal());
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    queryClient.removeQueries({ queryKey: ["getSubscriptionPlans", lang] });
    if (data?.data?.redirect_link) {
      window.open(data.data.redirect_link, "_self");
    }
    if (!data?.data?.redirect_link && data.data.page === "chats") {
      window.location.reload();
    }

    if (data.data.page === "segment") {
      router && router(`/submit-process/service-segments/${serviceId}/${sub_service_id}`);
    }
    yield put(BuySubService.actions.loadSuccess({ data: data.data }));
  } catch (e: any) {
    queryClient.removeQueries({ queryKey: ["getProfile", lang] });
    alert({
      message: e?.response?.data?.error ?? "مشکلی پیش آمده",
      type: "error",
    });
    yield put(BuySubService.actions.loadFailure(e.message));
  }
}

export function* buySubServiceSagas() {
  yield takeEvery(BuySubService.actionTypes.load, watchBuySubService);
}

export function useBuySubService() {
  const { loading, data, ...buySubServiceState } = useAppSelector((state) => state.buySubService);
  const dispatch = useAppDispatch();

  const dispatchBuySubService = useCallback(
    (data: {
      sub_service_id?: number;
      use_wallet?: boolean;
      user_service_id: number;
      router?: any;
      serviceId?: number;
    }) => {
      dispatch(BuySubService.actions.load(data));
    },
    [dispatch],
  );

  return {
    ...buySubServiceState,
    dispatchBuySubService,
    buySubServiceLoading: loading,
    buySubServiceData: data,
  };
}

export const {
  actionTypes: buySubServiceActionsTypes,
  actions: buySubServiceActions,
  reducer: buySubServiceReducer,
} = BuySubService;
